import { render, staticRenderFns } from "./FFormGeneral.vue?vue&type=template&id=ce5bbea0&scoped=true&"
import script from "./FFormGeneral.vue?vue&type=script&lang=js&"
export * from "./FFormGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5bbea0",
  null
  
)

export default component.exports